import { Button } from '@interstate/components/Button';
import { ChevronRightIcon } from '@interstate/components/Icons';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';

import { OUTSIDE_LIENHOLDER_HEADER_NAME } from '../../../../baseDealActivity/OutsideLienholder/constants';
import { useOutsideLienholderForm } from '../../../../baseDealActivity/OutsideLienholder/useOutsideLienholderForm';
import { SingleTradeInFormProvider } from '../../../../tradeForm/MultiTradeIn/TradeInFormProvider';
import { RowLabel, RowValue, ToggleChevron } from '../../../ScenarioGrid.style';
import { useOutsideLienholderExpansion } from './OutsideLienholderExpansion';
import { RowLabelAction } from '../../RowLabelAction';
import { ScenarioRow } from '../../ScenarioRow';
import { OutsideLienholderFields } from './OutsideLienholderFields';

export const CLEAR_ALL = 'Clear All';

export const OutsideLienholderRow = () => {
    const theme = useInterstateTheme();
    const { isExpanded, toggle } = useOutsideLienholderExpansion();
    const { lienholderProps, onClearAll } = useOutsideLienholderForm();

    return (
        <>
            <ScenarioRow rowKey="outsideLienholder">
                <RowLabel theme={theme}>
                    <RowLabelAction onActivate={toggle} expanded={isExpanded} testId="outside-lienholder-toggle">
                        <ToggleChevron $isExpanded={isExpanded} aria-hidden>
                            <ChevronRightIcon fontSize={11} data-testid={OUTSIDE_LIENHOLDER_HEADER_NAME} />
                        </ToggleChevron>
                        {OUTSIDE_LIENHOLDER_HEADER_NAME}
                    </RowLabelAction>
                </RowLabel>
                <RowValue>
                    {isExpanded && (
                        <Button buttonStyle="tertiary" size="small" data-testid="lienholder-clear-all-button" onClick={onClearAll}>
                            {CLEAR_ALL}
                        </Button>
                    )}
                </RowValue>
            </ScenarioRow>
            {isExpanded && (
                <SingleTradeInFormProvider tradeInIndex={0} isOutsideLienholder={true}>
                    <OutsideLienholderFields {...lienholderProps} />
                </SingleTradeInFormProvider>
            )}
        </>
    );
};
